<template>
  <div>
    <component :is="pageComponent.component" v-if="pageComponent.match" />
    <SitePage v-else-if="pageSlug" :slug="pageSlug" />
    <SitePagesRoot v-else v-model:page="page" />
  </div>
</template>

<script setup lang="ts">
const SitePage = defineAsyncComponent(
  () => import('@/async-components/Site/Pages/Page.vue')
);
const SitePagesRoot = defineAsyncComponent(
  () => import('@/async-components/Site/Pages/Root.vue')
);

const params = useUrlParams();

const localePath = useLocalePath();

const paramsWithoutPage = computed(() => {
  return params.value.filter(
    param => param && !param.endsWith(`-${t('paramsKeys.page')}`)
  );
});

const { t } = useI18n();

const pages = [
  // {
  //   routeKey: 'calculator',
  //   component: () =>
  //     import('@/async-components/Site/Institutional/MortgageCalculator.vue')
  // },
  // {
  //   routeKey: 'marketReport',
  //   component: () => import('@/async-components/Site/Institutional/MarketReport.vue')
  // }
].map(page => ({
  ...page,
  routes: [
    t(`routes.${page.routeKey}`, null, { locale: 'us' }),
    t(`routes.${page.routeKey}`, null, { locale: 'es' })
  ]
}));

const pageComponent = computed(() => {
  const slug = paramsWithoutPage.value?.[0];

  if (slug) {
    const component = pages.find(page => page.routes.includes(slug))?.component;
    if (component) {
      return { match: true, component: defineAsyncComponent(component) };
    }
  }
  return { match: false, component: null };
});

const route = useRoute();

const page = computed({
  get: () => {
    const pageParam = params.value.find(param =>
      param.endsWith(`-${t('paramsKeys.page')}`)
    );
    return pageParam ? parseInt(pageParam.split('-')[0]) : 1;
  },
  set: (v: number) => {
    const newPath = localePath(
      `/${t('routes.institutional')}` +
        (paramsWithoutPage.value.length
          ? `/${paramsWithoutPage.value.join('/')}`
          : '') +
        (v > 1 ? `/${v}-${t('paramsKeys.page')}` : '')
    );

    if (newPath !== route.path) {
      navigateTo(newPath);
    }
  }
});

const pageSlug = computed(() => {
  if (paramsWithoutPage.value.length > 1) {
    // navigateTo(localePath(`/${t('routes.institutional')}`), {
    //   replace: true,
    //   redirectCode: 301
    // });

    showError({
      statusCode: 404,
      message: t('common.pageNotFound'),
      fatal: true
    });

    throw new Error(t('common.pageNotFound'));
  } else if (paramsWithoutPage.value.length === 1) {
    return paramsWithoutPage.value[0];
  }
});
</script>
